import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=3952cae4&scoped=true"
import script from "./InfoList.vue?vue&type=script&lang=js"
export * from "./InfoList.vue?vue&type=script&lang=js"
import style0 from "./InfoList.vue?vue&type=style&index=0&id=3952cae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952cae4",
  null
  
)

export default component.exports